import React, { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { Box, Stack, Typography, IconButton,  } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';


import { unselectFeature } from 'handimap-react-lib/store/actions/selectedFeatureActions';
import { setContentType, setOpenSideBar } from 'handimap-react-lib/store/actions/sideBarActions';
import { SelectedSectionDetails } from 'handimap-react-lib/containers/SelectedDetails/SelectedSectionDetails';
import { SelectedFeatureDetails } from '../components/SelectedFeatureDetails';
import theme from '../theme';
import { SelectedGraphDetails } from 'handimap-react-lib/containers/SelectedDetails/SelectedGraphDetails';
import { CardInfoGraph } from '../components/CardInfoGraph';
import { unFocusElement } from 'handimap-react-lib/store/actions/focusActions';


export const SelectedDetails = ({contentType, isMobile, status, feature, backSection, typeAcc}) => {
  const dispatch = useDispatch();
  const {t} = useTranslation();
  const {palette} = theme;
  const getFeatureInfoAttrs = useSelector(state => state.layerConf.getFeatureInfoAttrs);
  const lastFocused = useSelector(state => state.focus.focused);
  const elementFocused = useSelector(state => state.focus.elem);

  const goBack = async () => {
    dispatch(unselectFeature());
    dispatch(setOpenSideBar(false));
    if (lastFocused) {
      elementFocused.focus({focusVisible: true});
      dispatch(unFocusElement());
    }
    if (isMobile) {
      await new Promise(res => setTimeout(res, 50));
    }
    dispatch(setContentType(backSection));
  };

  useEffect(() => {
    if(status === 'loading') {
      goBack();
    } else {
      return;
    }
  }, [status]);

  const renderDetails = () => {
    // const layerID = feature.layer.id;
    if(contentType === 'selectedFeatureDetails') {
      return (
        <SelectedFeatureDetails 
          isMobile={isMobile} 
          selectedFeature={feature}
          layer_id={feature.layer.id}
          getFeatureInfoAttrs={getFeatureInfoAttrs}
        />
      );
    }
    if (contentType === 'selectedPathDetails') {
      return (
        <SelectedSectionDetails feature={feature} typeAcc={typeAcc}/>
      );
    }
    if (contentType === 'selectedGraphDetails') {
      return (
        <SelectedGraphDetails feature={feature} CardInfoGraph={CardInfoGraph}/>
      );
    }
  };


  return (
    <Stack sx={{display: 'flex', width: '100%', height: '100%', backgroundColor: palette.primary.main}} direction='column' spacing={1}>
      <Box sx={{
        display: 'flex',
        backgroundColor: palette.primary.main,
        justifyContent: 'space-between',
        alignItems: 'center',
        position:'sticky',
        top:0,
        paddingY: '1em',
        zIndex:100
      }}>
        <IconButton onClick={goBack} >
          <FontAwesomeIcon style={{padding: '.5em'}} color='white' icon={faArrowLeft} />
          <Typography sx={{ fontSize: '1em', color: 'white', marginLeft: '10px' }}>
            {t('common.return-side-bar')}
          </Typography>
        </IconButton>
      </Box>
      <Box sx={{display: 'flex', width: '100%', paddingY: '2em'}}>
        {renderDetails()}
      </Box>
    </Stack>
  );
};